import Controller from './controller';
import { PrimaryTextXs, NoteText } from 'atoms';
import internalState from './internalState';
import { ContainerComponent, wrap } from 'AppReact';
import { NoteMessageWrapper, Mt1, Mx3, FullWidthJustifyEndWrapper } from 'wrappers';
import { TextButton } from 'molecules';
import { getNoteText } from 'utils';
import NoteMediaFiles from '../noteMediaFiles';

export const definition = {
  name: 'Note',
  controller: Controller,
  initialProps: ({ event, currentUser }) => ({ event, currentUser }),
  props: internalState,
  elements: [
    {
      wrapper: NoteMessageWrapper,
      name: 'NoteBody',
      displayState: ({ event, currentUser }) => ({ hasImage: !!event?.src && event?.file_type?.includes("image"), hasVideo: !!event?.src && event?.file_type?.includes("image"), right: currentUser === event?.created_by }),
      elements: [
        {
          component: PrimaryTextXs,
          name: 'SenderName',
          displayValue: ({ event }) => `${event?.created_by} ${event?.created_by_type === 'resident' ? '(Resident)' : ''}`,
        },
        {
          component: wrap(NoteMediaFiles, Mt1),
          name: 'Image',
          renderIf: ({ event }) => !!event.attachments,
          bindings: ({ event }) => ({
            files: event.attachments,
            popup: { text: 'Click to see full screen', position: 'top' }
          })
        },
        {
          component: wrap(NoteText, Mt1),
          name: 'NoteText',
          displayValue: ({ event, translated, translation }) => {
            if (translated) {
              return getNoteText(translation)
            } else {
              return getNoteText(event?.description)
            }
          }
        },
        {
          component: wrap(TextButton, FullWidthJustifyEndWrapper),
          name: 'TranslateButton',
          renderIf: ({ event }) => event?.description,
          bindings: ({ translated, event, translation }) => ({ title: translated ? 'Translate' : 'Traducir', translated, event, translation })
        }
      ]
    },
  ]
};

export default wrap(ContainerComponent(definition), Mx3);